<!--
  Side view of the Provisionssatz (cp.ProvisionContractAgent). Compact shape after
  cp-provision-agent-side.component.html: the wide blocks only on explicit request, otherwise
  identity + amounts + liability stacked.
-->
@if (initialized && dto) {

    <div class="cp-provision-contract-agent-side mt-3">

        @if (activeNavigationItem?.action == 'transactions') {
            <cp-provision-contract-agent-transactions
                    [provisionContractAgentId]="objectIdentifier.objectId">
            </cp-provision-contract-agent-transactions>
        } @else if (activeNavigationItem?.action == 'contract') {
            <cp-provision-contract-agent-contract
                    [provisionContractAgentId]="objectIdentifier.objectId"
                    [columns]="1">
            </cp-provision-contract-agent-contract>
        } @else if (activeNavigationItem?.action == 'cancellation') {
            <cp-provision-contract-agent-cancellation
                    [provisionContractAgentId]="objectIdentifier.objectId">
            </cp-provision-contract-agent-cancellation>
        } @else {
            <cp-provision-contract-agent-base-data
                    [provisionContractAgentId]="objectIdentifier.objectId"
                    [columns]="1">
            </cp-provision-contract-agent-base-data>

            <div class="mt-3">
                <cp-provision-contract-agent-amounts
                        [provisionContractAgentId]="objectIdentifier.objectId"
                        [columns]="1">
                </cp-provision-contract-agent-amounts>
            </div>

            <div class="mt-3">
                <cp-provision-contract-agent-liability
                        [provisionContractAgentId]="objectIdentifier.objectId"
                        [columns]="1">
                </cp-provision-contract-agent-liability>
            </div>
        }

    </div>

}
